export default "__VITE_ASSET__CApJ6CBq__"